// extracted by mini-css-extract-plugin
export default {"root":"Register_root__TONgU","logo":"Register_logo__dl6ys","card":"Register_card__SsL7o","title":"Register_title__nO7ri","formContainer":"Register_formContainer__BqL-t"};